import React, { ReactElement } from 'react';
import './terminDetailEmptyDataMessage.scss';

interface Props {
  text: string;
}

const TerminDetailEmptyDataMessage = ({ text } : Props): ReactElement => (
  <>
    <div className="termin-detail-empty-data-message">{text}</div>
  </>
);

export default TerminDetailEmptyDataMessage;
